<template>
	<div class="st-main-content">
		<div class="query-setting-box">
			<div class="query-setting-box-left">
				<div class="order-query-form-box">
					<label for="start-date">手机：</label>
					<span class="order-query-form-input"><input type="text" v-model="orderForm.phone"></span>
				</div>
			</div>
			<div class="order-query-form-box">
				<label for="start-date">余额>0</label>
				<el-switch
                v-model="orderForm.hasMoney"
                active-color="#13ce66"
                inactive-color="#ff4949">
                </el-switch>
			</div>
			<div class="order-query-form-box-right">
				<span class="order-query-form-submit stPointer" @click="searchList(true)">查询</span>
			</div>
		</div>

		<div class="data-table-box">
			<common-table ref="CommonTableRef" 
				:tableColumns="tableColumns" 
				:data="dataList" 
				:loading="loading"
				:showPage="togglePage"
				:showSummary="true" 
				:count-data="dataTotal"

				:pageConfig="pageConfig"
				:bottomHandleArr="bottomHandleArr" 
				@selectionChange="selectionChange" 
				@currentChange="currentChange"
				@sizeChange="sizeChange">
			</common-table>
		</div>

	</div>
</template>
<script>
export default {
	name: 'DriverAccount',
	props: [],
	components: {},
	data(){
		return{
			tableColumns:[
				{
					key:'name',
					title:'货主名称',
				},{
					key:'phone',
					title:'货主手机',
				},{
					key:'accountBalanceFee',
					title:'钱包余额',
				},{
					key:'rechargeFee',
					title:'充值金额',
				},{
					key:'consumeFee',
					title:'消费金额',
				},{
					key:'registrayDate',
					title:'注册时间',
				}
			],
			loading:false,
			dataList:[], //订单列表
			dataTotal: {},
			orderForm:{
                hasMoney: false,
				phone: null, //	司机手机	string	
			},
			pageConfig: {
				total: 0,
				pageSize: 100,
				currentPage: 1,
			},
			bottomHandleArr:[
				{
					label: '导出',
					type: 'success',
					handler: () => this.exportTable()
				},
			],
			togglePage:false, //是否显示分页
			selDriverId:null, //选中的司机
			selectedList:[],// 选中的列表
			driverList:[],// 司机列表
			toggleStDialog:false,// 弹窗
			marginStatusList:[{
					value: 0,
					label: '未缴纳'
				}, {
					value: 1,
					label: '已缴纳'
				}, {
					value: 2,
					label: '申请退回'
				},{
					value: 3,
					label: '已拒绝'
				},{
					value: 4,
					label: '已退回'
			}],
		}
	},
	created() {},
	methods: {
		sizeChange(size) {
			this.pageConfig.currentPage = 1
			this.pageConfig.pageSize = size
			this.searchList()
		},
		currentChange(currentPage) {
			this.pageConfig.currentPage = currentPage
			this.searchList()
      	},
		cellClass(row){     
			if (row.columnIndex === 0) {           
				return 'disabledCheck'     
			} 
		},
		selectionChange(val){
			this.selectedList=val;
		},
		searchList(flag){
			let pages={};
			pages.size = this.pageConfig.pageSize;
			pages.current = this.pageConfig.currentPage;
			if(flag) pages.current = 1;
			let orderForm=this.orderForm;
			Object.assign(orderForm,pages)
			this.getData(orderForm)
		},
		
		getData(data){
            this.loading=true;
			this.$server.financial.getOwnerAccountBalanceCount({
				...data,
				hasMoney:data.hasMoney?1:0
			}, (res) => {
				this.dataTotal = res.data
			})
			this.$server.financial.getOwnerAccountBalance({
				...data,
				hasMoney:data.hasMoney?1:0
			},(res)=>{
				this.loading=false;
				if(res.code==0){
					this.dataList=res.data.records;
					this.pageConfig.total = res.data.total;
					this.pageConfig.currentPage = res.data.current;
					if(res.data.total>0){
						this.togglePage=true;
					}
				}
			})
		},
		// 导出
		exportTable(){
			if (this.dataList.length < 1) {
				this.$toast.stMessage('暂无订单', true)
				return;
			}
			let pages = {};
			pages.size = this.pageConfig.pageSize;
			pages.current = this.pageConfig.currentPage;
			const sendData = {
				...this.orderForm,
				exportColumnFiledNames:  this.tableColumns.map((item) => {
						return  item.key
					}).filter(item => {
						return item && item.trim()
					})
            }
			Object.assign(sendData, pages)
			this.$server.common.exportTable('/finance/ownerAccountBalanceExport', {
				...sendData,
				hasMoney:sendData.hasMoney?1:0
			}, (res) => {
				console.log('导出成功')
			})
			
		},
	},
	mounted() {
		
	}
}

</script>
<style scoped>

.driver-account {
  width: 100%;
  height: auto;
}
.data-table-box {
	/* display: flex;
	justify-content: center;
	align-items: center; */
    height: auto;
    background: #FFF;
    padding: 8px;
	box-sizing: border-box;
	text-align: center;
}	
.data-table-warp{
	/* display: inline-block; */
	width: auto;
	margin: 0 auto;
}
.data-table{
	margin-bottom: 8px;
	/* border: 1px solid #ccc; */
}
.query-setting-box-left{
    flex-grow: 0;
}
</style>
